import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import "react";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE_react_resizable_panels_8d5960a0__ from "react-resizable-panels";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
function ResizablePanelGroup({ className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_resizable_panels_8d5960a0__.PanelGroup, {
        "data-slot": "resizable-panel-group",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex h-full w-full data-[panel-group-direction=vertical]:flex-col", className),
        ...props
    });
}
function ResizablePanel({ ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_resizable_panels_8d5960a0__.Panel, {
        "data-slot": "resizable-panel",
        ...props
    });
}
function ResizableHandle({ withHandle, className, ...props }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_resizable_panels_8d5960a0__.PanelResizeHandle, {
        "data-slot": "resizable-handle",
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("bg-border focus-visible:ring-ring relative flex w-px items-center justify-center after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:ring-1 focus-visible:ring-offset-1 focus-visible:outline-hidden data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90", className),
        ...props,
        children: withHandle && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            className: "bg-border z-10 flex h-4 w-3 items-center justify-center rounded-xs border",
            children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.GripVerticalIcon, {
                className: "size-2.5"
            })
        })
    });
}
export { ResizableHandle, ResizablePanel, ResizablePanelGroup };
